import FaqPage from './FaqPage';
import React, { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import BrowserRouter from 'react-router-dom/BrowserRouter';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';

import {
	AppNotificationView,
} from './components/views';
import LandingPage from './LandingPage';
import NewsPage from './NewsPage';
import PricingPage from './PricingPage';
import SamplesPage from './SamplesPage';

export default class Router extends Component {
	render () {
		return (
			<BrowserRouter>
				<Fragment>
					<Switch>
						<Route
							path='/faq'
							render={({ history }) => {
								if (history.location.hash) {
									return (
										<Redirect
											to={`/${history.location.hash}`}
										/>
									);
								} else {
									return <FaqPage />;
								}
							}}
						/>
						<Route
							path='/news'
							render={({ history }) => {
								if (history.location.hash) {
									return (
										<Redirect
											to={`/${history.location.hash}`}
										/>
									);
								} else {
									return <NewsPage />;
								}
							}}
						/>
						<Route
							path='/pricing'
							render={({ history }) => {
								if (history.location.hash) {
									return (
										<Redirect
											to={`/${history.location.hash}`}
										/>
									);
								} else {
									return <PricingPage />;
								}
							}}
						/>
						<Route
							path='/samples'
							render={({ history }) => {
								if (history.location.hash) {
									return (
										<Redirect
											to={`/${history.location.hash}`}
										/>
									);
								} else {
									return <SamplesPage />;
								}
							}}
						/>
						<Route component={LandingPage} />
					</Switch>
					<AppNotificationView />
				</Fragment>
			</BrowserRouter>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Router.js